module.exports = __webpack_public_path__ + "static/img/fitPlanBan11.8c0269c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/fitPlanBan11.png
// module id = Kafv
// module chunks = 1